/* eslint-disable formatjs/no-literal-string-in-jsx */
import React, { FunctionComponent } from 'react'
import { View } from 'react-native'

import styled from 'styled-components/native'

import { InfoIcon } from '../../atoms/icons/InfoIcon'
import { TextButton } from '../../atoms/textButton/TextButton'
import { Title } from '../../atoms/title/Title'
import { Tooltip } from '../../atoms/tooltip/Tooltip'
import { TitleSize } from '../../styles/typeStyles'
import { tID } from '../../utils/utils'

export interface PlatformEngagementYTDCardHeaderProps {
  onViewQuarterlyDetailsClicked: () => void
}

const Container = styled.View({
  flexDirection: 'row',
  justifyContent: 'space-between',
})
const TitleInnerContainer = styled.View(({ theme }) => ({
  flexDirection: 'row',
  gap: theme.spacing['4px'],
  alignItems: 'center',
}))

export const PlatformEngagementYTDCardHeader: FunctionComponent<PlatformEngagementYTDCardHeaderProps> = ({
  onViewQuarterlyDetailsClicked,
}) => {
  return (
    <Container>
      <View>
        <TitleInnerContainer>
          <Title text='Platform Engagement YTD' size={TitleSize.MEDIUM} />
          <Tooltip
            hoverEnabled
            content={
              'Completed and drop out episodes for the performance year. \n\nTo meet expectations, clinicians must achieve both >= 80% assignment rate and >= 25% feedback rate.'
            }
            placement='right'
          >
            <InfoIcon size={24} />
          </Tooltip>
        </TitleInnerContainer>
      </View>
      <TextButton
        testID={tID('PlatformEngagementYTDCardHeaderQuarterlyDetailsButton')}
        onPress={onViewQuarterlyDetailsClicked}
        text='View quarterly details'
      />
    </Container>
  )
}
